import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableNetwork, disableNetwork } from 'firebase/firestore';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Only log in development
const isDev = typeof window !== 'undefined' ? window.location.hostname === 'localhost' : false;

// Initialize Firebase - check for existing app to prevent duplicates
let app;
const existingApps = getApps();
if (existingApps.length === 0) {
  app = initializeApp(firebaseConfig);
  if (isDev) {
    console.log('🔥 Shared Firebase config: initialized new app');
  }
} else {app = existingApps[0];
  if (isDev) {
    console.log('🔥 Shared Firebase config: using existing app');
  }
}

if (isDev) {
  console.log('Firebase configuration:', {
    projectId: firebaseConfig.projectId,
    authDomain: firebaseConfig.authDomain,
    storageBucket: firebaseConfig.storageBucket,
    messagingSenderId: firebaseConfig.messagingSenderId,
    appId: firebaseConfig.appId
  });
}

const auth = getAuth(app);
const db = getFirestore(app);

// Monitor Firestore connection and retry on failure
const monitorConnection = () => {
  if (typeof window !== 'undefined') {
    window.addEventListener('online', () => {
      // Only log in development
      if (isDev) {
        console.log('Network online, enabling Firestore');
      }
      enableNetwork(db);
    });
    
    window.addEventListener('offline', () => {
      // Only log in development
      if (isDev) {
        console.log('Network offline, disabling Firestore');
      }
      disableNetwork(db);
    });
  }
};

// Initialize connection monitoring
monitorConnection();

// Only log in development
if (isDev) {
  console.log('Firebase initialized successfully');
}

export { auth, db }; 